import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router';
import { ReactNode } from 'react';
import * as React from 'react';

import { TypographyH2, TypographyH3 } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

export function SectionHeading({
  id,
  children,
  className,
}: {
  id: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <TypographyH2 id={id} className={cn('mt-12', className)}>
      {children}
    </TypographyH2>
  );
}

export function SectionSubheading({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <TypographyH3 className={cn('mt-8', className)}>
      <ChevronRight className="w-6 h-6 inline-block mr-2" />
      {children}
    </TypographyH3>
  );
}

export function TocLink({ id, label }: { id: string; label: string }) {
  return (
    <li className="flex items-center">
      <ChevronRight className="w-4 h-4 inline-block mr-2" />
      <Link to={`#${id}`} className="text-primary">
        {label}
      </Link>
    </li>
  );
}
